var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.77 9C44.3433 9 48.24 10.6333 51.46 13.9C54.7267 17.12 56.36 21.04 56.36 25.66C56.36 30.2333 54.7267 34.1533 51.46 37.42C48.24 40.64 44.3433 42.25 39.77 42.25H28.22V65H18V9H39.77ZM39.77 32.03C41.5433 32.03 43.0367 31.4233 44.25 30.21C45.51 28.95 46.14 27.4333 46.14 25.66C46.14 23.8867 45.51 22.37 44.25 21.11C43.0367 19.85 41.5433 19.22 39.77 19.22H28.22V32.03H39.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 0C70.4183 0 74 3.58172 74 8V66C74 70.4183 70.4183 74 66 74H8C3.58172 74 1.04695e-07 70.4183 0 66V8C0 3.58172 3.58172 1.04692e-07 8 0H66ZM7.0459 4C5.36376 4.00014 4.00014 5.36376 4 7.0459V66.9541C4.00014 68.6362 5.36376 69.9999 7.0459 70H66.9541C68.6362 69.9999 69.9999 68.6362 70 66.9541V7.0459C69.9999 5.36376 68.6362 4.00014 66.9541 4H7.0459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSymbol);
export default __webpack_public_path__ + "static/media/p_symbol.36c67ac5d754b9323a6d8b38b6c8fb48.svg";
export { ForwardRef as ReactComponent };